import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-[#0F172A] text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <img 
                src="/images/logo.avif" 
                alt="CBL Ar Condicionados Logo" 
                className="h-12 w-12 object-contain rounded-full"
              />
              <div className="flex flex-col">
                <span className="text-xl font-bold">CBL</span>
                <span className="text-xs text-gray-400">Ar Condicionados</span>
              </div>
            </div>
            <p className="text-gray-400 text-sm mb-4">
              CBL Ar Condicionados, fica nas proximidades do Centro e bairros de Curitiba. Fazemos instalação de ar condicionados, reparos, recarga de gás, limpeza, higienização preventiva e Elétrica.
            </p>
            <div className="flex items-center gap-3">
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="w-9 h-9 flex items-center justify-center bg-white/10 rounded-full hover:bg-orange-500 transition-colors cursor-pointer">
                <i className="ri-facebook-fill"></i>
              </a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="w-9 h-9 flex items-center justify-center bg-white/10 rounded-full hover:bg-orange-500 transition-colors cursor-pointer">
                <i className="ri-instagram-line"></i>
              </a>
              <a href="https://youtube.com" target="_blank" rel="noopener noreferrer" className="w-9 h-9 flex items-center justify-center bg-white/10 rounded-full hover:bg-orange-500 transition-colors cursor-pointer">
                <i className="ri-youtube-line"></i>
              </a>
            </div>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4">Links Rápidos</h3>
            <ul className="space-y-2">
              <li><Link to="/" className="text-gray-400 hover:text-orange-500 transition-colors text-sm cursor-pointer">Home</Link></li>
              <li><Link to="/sobre" className="text-gray-400 hover:text-orange-500 transition-colors text-sm cursor-pointer">Sobre nós</Link></li>
              <li><Link to="/contato" className="text-gray-400 hover:text-orange-500 transition-colors text-sm cursor-pointer">Contato</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4">Serviços</h3>
            <ul className="space-y-2">
              <li><Link to="/instalacao" className="text-gray-400 hover:text-orange-500 transition-colors text-sm cursor-pointer">Instalação de Ar Condicionado</Link></li>
              <li><Link to="/conserto" className="text-gray-400 hover:text-orange-500 transition-colors text-sm cursor-pointer">Conserto de Ar Condicionado</Link></li>
              <li><Link to="/higienizacao" className="text-gray-400 hover:text-orange-500 transition-colors text-sm cursor-pointer">Higienização de Ar Condicionado</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4">Contacto</h3>
            <ul className="space-y-3">
              <li className="flex items-start gap-2 text-sm">
                <i className="ri-phone-line text-orange-500 mt-0.5"></i>
                <a href="tel:+5541996365014" className="text-gray-400 hover:text-orange-500 transition-colors cursor-pointer">(41) 99636-5014</a>
              </li>
              <li className="flex items-start gap-2 text-sm">
                <i className="ri-mail-line text-orange-500 mt-0.5"></i>
                <a href="mailto:contato@cblarcondicionados.com.br" className="text-gray-400 hover:text-orange-500 transition-colors cursor-pointer">contato@cblarcondicionados.com.br</a>
              </li>
              <li className="flex items-start gap-2 text-sm">
                <i className="ri-time-line text-orange-500 mt-0.5"></i>
                <span className="text-gray-400">Seg–Sex, 9h–18h</span>
              </li>
              <li className="flex items-start gap-2 text-sm">
                <i className="ri-map-pin-line text-orange-500 mt-0.5"></i>
                <span className="text-gray-400">R. Mato Grosso, 1794 - Água Verde, Curitiba - PR, 80630-070</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 pt-6">
          <div className="flex flex-col lg:flex-row justify-between items-center gap-4 mb-4">
            <div className="flex flex-wrap justify-center lg:justify-start gap-4 text-xs text-gray-400">
              <Link to="/politica-privacidade" className="hover:text-orange-500 transition-colors cursor-pointer whitespace-nowrap">Política de Privacidade</Link>
              <Link to="/politica-cookies" className="hover:text-orange-500 transition-colors cursor-pointer whitespace-nowrap">Política de Cookies</Link>
              <a href="https://www.livroreclamacoes.pt" target="_blank" rel="noopener noreferrer" className="hover:text-orange-500 transition-colors cursor-pointer whitespace-nowrap">Livro de Reclamações</a>
              <Link to="/areas-atendimento" className="hover:text-orange-500 transition-colors cursor-pointer whitespace-nowrap">Áreas de Atendimento</Link>
            </div>
            <a href="https://readdy.ai/?origin=logo" target="_blank" rel="noopener noreferrer" className="text-xs text-gray-400 hover:text-orange-500 transition-colors cursor-pointer whitespace-nowrap">
              Website Builder
            </a>
          </div>

          <div className="bg-orange-500/10 border border-orange-500/20 rounded-lg p-4 mb-4">
            <p className="text-xs text-gray-400 leading-relaxed">
              <i className="ri-information-line text-orange-500 mr-1"></i>
              CBL Ar Condicionados, fica nas proximidades do Centro e bairros de Curitiba. Fazemos instalação de ar condicionados, reparos, recarga de gás, limpeza, higienização preventiva e Elétrica.
            </p>
          </div>

          <div className="text-center text-sm text-gray-400">
            <p>CBL Ar Condicionados ® 2025. Todos os direitos reservados.</p>
          </div>
        </div>
      </div>
    </footer>
  );
}